import { useState } from "react";
import { CustomModal, TextInput, Button, showToast } from "../shared";
import { useDeleteProject } from "../../lib/react-query/projects";
import { extractBackendErrorMessage } from "../../utils/utils";

const DeleteProjectModal = ({ isOpen, onClose, projectId, projectTitle, onDeleted }) => {
  const [confirmName, setConfirmName] = useState("");
  const { mutateAsync: deleteProject, isPending: deletingProject } = useDeleteProject();

  const handleDelete = async () => {
    try {
      await deleteProject({ projectId });
      showToast("Project deleted successfully", "success");
      onClose?.();
      onDeleted?.();
    } catch (err) {
      showToast(extractBackendErrorMessage(err, "Failed to delete project"), "error");
    }
  };

  const match = confirmName.trim() === String(projectTitle || "").trim();

  return (
    <CustomModal title={"Delete Project"} open={isOpen} close={onClose} showPrimaryButton={false} showSecondaryButton={false}>
      <div className="space-y-3">
        <p className="text-sm text-darkgrey">This action cannot be undone. To confirm deletion, type the project name below.</p>
        <TextInput label="Project name" type="text" name="confirmName" value={confirmName} onChange={(e) => setConfirmName(e.target.value)} />
        <div className="flex items-center justify-end gap-2">
          <Button className="rounded-lg" variant="outlined" color="secondary" size="md" disabled={deletingProject} onClick={onClose}>Cancel</Button>
          <Button className="rounded-lg" color="primary" size="md" loading={deletingProject} disabled={deletingProject || !match} onClick={handleDelete}>Delete</Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default DeleteProjectModal;
